import { _unsubscribeDialogActionFailedText } from 'owa-locstrings/lib/strings/_unsubscribedialogactionfailedtext.locstring.json';
import { unsubscribeDialogActionFailed } from 'owa-locstrings/lib/strings/unsubscribedialogactionfailed.locstring.json';
import loc from 'owa-localize';
import { confirm } from 'owa-confirm-dialog';
import removeInfoBarMessageInReadingPane from 'owa-info-bar/lib/actions/removeInfoBarMessage';
import { getSelectedTableView } from 'owa-mail-list-store';
import { readingPaneStore } from 'owa-mail-reading-pane-store';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';

import { mutator } from 'satcheljs';
import { UnsubscribeResponseType, onAfterUnsubscribe } from 'owa-brands-subscription';

export default mutator(onAfterUnsubscribe, actionMessage => {
    if (actionMessage.unsubscribeSourceType !== 'BrandCard') {
        return;
    }

    if (actionMessage.responseType === UnsubscribeResponseType.Success) {
        const listViewType = getSelectedTableView().tableQuery.listViewType;
        if (listViewType === ReactListViewType.Conversation) {
            const { itemPartsMap } = readingPaneStore.conversationReadingPaneViewState;
            itemPartsMap.forEach(itemPart => {
                removeInfoBarMessageInReadingPane(itemPart, 'unsubscribeInfoBar');
            });
        } else {
            removeInfoBarMessageInReadingPane(
                readingPaneStore.itemReadingPaneViewState.itemViewState,
                'unsubscribeInfoBar'
            );
        }
    } else {
        confirm(
            loc(unsubscribeDialogActionFailed),
            loc(_unsubscribeDialogActionFailedText),
            false,
            {
                hideCancelButton: true,
            }
        );
    }
});
